import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import {
  NgbAccordionModule,
  NgbCollapseModule,
} from "@ng-bootstrap/ng-bootstrap";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule,
} from "ngx-perfect-scrollbar";

import { AngularEditorModule } from "@kolkov/angular-editor";
import { SelectModule } from "ng-select";
import { TagInputModule } from "ngx-chips";
import { ClickOutsideModule } from "ng-click-outside";

import { TitleComponent } from "../layout/title/title.component";
import { ShowAuthedDirective } from "./services";

import {
  AccordionAnchorDirective,
  AccordionLinkDirective,
  AccordionDirective,
  CardComponent,
  CardToggleDirective,
  ModalBasicComponent,
  ModalAnimationComponent,
  SpinnerComponent,
} from "./theme-elements";

import {
  ListErrorsComponent,
  RemoveAlertDirective,
  LoaderAnimationComponent,
  NoContentMsgComponent,
} from "./components";

import {
  DiscussionPreviewComponent,
  DiscussionListComponent,
  CommunityPreviewComponent,
  CommunityListComponent,
  InviteCardListComponent,
  InviteCardPreviewComponent,
  InviteNotificationListComponent,
  InviteNotificationPreviewComponent,
  GeneralNotificationListComponent,
  GeneralNotificationPreviewComponent,
  MembershipListComponent,
  MembershipPreviewComponent,
  VoterListComponent,
  VoterPreviewComponent,
  CommentListComponent,
  ParentCommentComponent,
  ChildCommentComponent,
} from "./components/lists";

import {
  UpvoteDiscussionButtonComponent,
  DownvoteDiscussionButtonComponent,
  UpvoteCommentButtonComponent,
  DownvoteCommentButtonComponent,
  FollowButtonComponent,
  AddCommentButtonComponent,
  EditCommentButtonComponent,
  EditCredentialButtonComponent,
  ShowMembersButtonComponent,
  ShowVotersButtonComponent,
  UploadImageButtonComponent,
  SocialAuthButtonComponent,
  SocialShareButtonsComponent,
  NotificationAlertButtonComponent,
  InviteAlertButtonComponent,
  PaginationButtonsComponent,
  DelCommunityButtonComponent,
  DelAccountButtonComponent,
  DelMembershipButtonComponent,
  DelPanelSeatButtonComponent,
  InviteToCommunityButtonComponent,
  InviteToDiscussionButtonComponent,
  BookmarkDiscussionButtonComponent,
} from "./components/buttons";

import {
  InviteToCommunityModal,
  InviteToCommunityForm,
  InviteToDiscussionModal,
  InviteToDiscussionForm,
  CommentEditorModal,
  CommentEditorForm,
  CredentialEditorModal,
  CredentialEditorForm,
  MembershipListModal,
  VoterListModal,
  ImageUploadModal,
  ImageUploadForm,
  NotificationAlertsModal,
  InviteAlertsModal,
  DelCommunityAuthModal,
  DelCommunityAuthForm,
  DelAccountAuthModal,
  DelAccountAuthForm,
  DelMembershipAuthModal,
  DelMembershipAuthForm,
  DelPanelSeatAuthModal,
  DelPanelSeatAuthForm,
} from "./components/modals";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

const MODALS: any[] = [
  ModalBasicComponent,
  ModalAnimationComponent,
  InviteToCommunityModal,
  InviteToDiscussionModal,
  CommentEditorModal,
  CredentialEditorModal,
  MembershipListModal,
  VoterListModal,
  ImageUploadModal,
  NotificationAlertsModal,
  InviteAlertsModal,
  DelCommunityAuthModal,
  DelAccountAuthModal,
  DelMembershipAuthModal,
  DelPanelSeatAuthModal,
];

const COMPONENTS: any[] = [
  TitleComponent,
  CardComponent,
  SpinnerComponent,
  ListErrorsComponent,
  FollowButtonComponent,
  UpvoteDiscussionButtonComponent,
  DownvoteDiscussionButtonComponent,
  UpvoteCommentButtonComponent,
  DownvoteCommentButtonComponent,
  AddCommentButtonComponent,
  EditCommentButtonComponent,
  EditCredentialButtonComponent,
  ShowMembersButtonComponent,
  ShowVotersButtonComponent,
  UploadImageButtonComponent,
  SocialAuthButtonComponent,
  SocialShareButtonsComponent,
  NotificationAlertButtonComponent,
  InviteAlertButtonComponent,
  PaginationButtonsComponent,
  DelCommunityButtonComponent,
  DelAccountButtonComponent,
  DelMembershipButtonComponent,
  DelPanelSeatButtonComponent,
  BookmarkDiscussionButtonComponent,
  DiscussionPreviewComponent,
  DiscussionListComponent,
  CommunityPreviewComponent,
  CommunityListComponent,
  InviteCardListComponent,
  InviteCardPreviewComponent,
  InviteNotificationListComponent,
  InviteNotificationPreviewComponent,
  GeneralNotificationListComponent,
  GeneralNotificationPreviewComponent,
  MembershipListComponent,
  MembershipPreviewComponent,
  VoterListComponent,
  VoterPreviewComponent,
  CommentListComponent,
  ParentCommentComponent,
  ChildCommentComponent,
  InviteToCommunityForm,
  InviteToDiscussionForm,
  CommentEditorForm,
  CredentialEditorForm,
  ImageUploadForm,
  DelCommunityAuthForm,
  DelAccountAuthForm,
  DelMembershipAuthForm,
  DelPanelSeatAuthForm,
  LoaderAnimationComponent,
  NoContentMsgComponent,
  InviteToCommunityButtonComponent,
  InviteToDiscussionButtonComponent,
];

const DIRECTIVES: any[] = [
  AccordionAnchorDirective,
  AccordionLinkDirective,
  AccordionDirective,
  CardToggleDirective,
  RemoveAlertDirective,
  ShowAuthedDirective,
];

const MODULES = [
  HttpClientModule,
  CommonModule,
  PerfectScrollbarModule,
  ClickOutsideModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule,
  AngularEditorModule,
  SelectModule,
  TagInputModule,
  NgbAccordionModule,
  NgbCollapseModule,
];

const PIPES: any[] = [];

@NgModule({
  imports: [NgbModule, MODULES],
  exports: [NgbModule, MODULES, COMPONENTS, DIRECTIVES, PIPES, MODALS],
  declarations: [COMPONENTS, DIRECTIVES, PIPES, MODALS],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
})
export class SharedModule {}
